import React from 'react'
import styles from './control-label.module.scss'
import clsx from 'clsx'
import PropTypes from 'prop-types'

const ControlLabel = ({
  value,
  control,
  name = 'name',
  label,
  disabled = false,
  className = '',
  error,
  hidden,
  ...rest
}) => {
  const Control = control
    ? React.cloneElement(control, {
        name,
        value,
        disabled,
        className: styles['control-label__element'],
        id: `name-${name}`,
        ...rest,
      })
    : null

  return (
    <label
      className={clsx(styles['control-label'], className, {
        [styles['control-label_hidden']]: hidden,
      })}
    >
      {Control}
      <span
        className={clsx(styles['control-label__label'], {
          [styles['control-label__label_hasError']]: error,
        })}
      >
        {label}
      </span>
    </label>
  )
}

ControlLabel.propTypes = {
  value: PropTypes.any,
  control: PropTypes.element,
  name: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  error: PropTypes.bool,
  hidden: PropTypes.bool,
  rest: PropTypes.object,
}

export default ControlLabel
